import { UserInfoContext } from "Context/CommonContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserRoles } from "utilFunctions/Constants/UserRoles";
const RequireAuth = ({ children, userroles }: any) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const navigate = useNavigate();
  let currentUserRole;
  if (userInfo) {
    currentUserRole = userInfo?.fexRole;
  }
  if (currentUserRole) {
    if (userroles) {
      if (userroles.includes(currentUserRole)) {
        return children;
      } else if (currentUserRole === UserRoles.academicCounsellor) {
        navigate("/admin/myBranch");
      } else {
        navigate("/admin/dashboard");
        return;
      }
    } else {
      return children;
    }
  }
};
export default RequireAuth;
